// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupField_wrapper__rChE6","heading":"GroupField_heading__I-77C"};